var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100",staticStyle:{"z-index":"1001"},attrs:{"name":"add-cpv-modal"}},[_c('div',{staticStyle:{"height":"100%"},attrs:{"id":"modal-body"}},[_c('cpv-selector',{attrs:{"id":"cpv-selector","selectedCpvs":this ? this.$attrs.selectedCpvs : []}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }